<template>
    <pendo-router-link
        v-pendo-tooltip="{
            classes: 'side-nav-tooltip',
            content: tooltipContent,
            placement: 'right',
            arrow: true,
        }"
        pendo-analytics="surveys-nav-item-upsell"
        data-cy="surveys-nav-link"
        class="nav-option"
        :class="{ selected, expanded }"
        :to="{ name: 'SurveysUpsell' }"
        :aria-label="label"
        @click="$emit('toggle', $event)"
        @keyup.enter="$emit('toggle', $event)">
        <div class="nav-icon">
            <surveys-nav-icon />
        </div>
        <div
            v-show="expanded"
            class="nav-label">
            <span class="label-text">{{ label }}</span>
            <upsell-tag />
        </div>
    </pendo-router-link>
</template>

<script>
import PendoRouterLink from '@/vue-router/pendo-router-link.vue';
import { PendoTooltip } from '@pendo/components';
import SurveysNavIcon from '@/side-nav/components/nav-icons/surveys-nav-icon.vue';
import UpsellTag from '@/common/tags/upsell-tag.vue';

export default {
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    components: {
        PendoRouterLink,
        SurveysNavIcon,
        UpsellTag,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        selected: {
            type: Boolean,
            default: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['toggle'],
    computed: {
        tooltipContent () {
            if (this.expanded) return '';

            return this.$t('sideNav.Available upgrade: Sentiment');
        },
        label () {
            return this.$t('sideNav.Surveys');
        },
    },
};
</script>

<style scoped lang="less">
@import '@/side-nav/nav.style.less';
</style>
